module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gJaEPL/tc-custom/9781683502319.jpg?1702092112774",
      "alt": "This image is the cover for the book Book Blueprint"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Book Blueprint\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“A superb . . . how-to book for any entrepreneur who not only wants to get their thoughts down to share with the world, but to leverage off their expertise.” –Geoff Hetherington, JG Hetherington, The Clarity CEO")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" With the availability of self-publishing services and the rise of the entrepreneur as a thought leader, writing a book is becoming more appealing to an increasing number of small business owners. The problem? Most businesspeople aren’t writers, have never written a book before, are time poor and don’t know where to start. While many want to write a book, they worry about investing months of their time and thousands of their dollars to write something that isn’t any good, or even whether they will finish. "), _c('i', [_vm._v("Book Blueprint")]), _vm._v(" gives a step-by-step framework that any entrepreneur can follow to write a great book quickly, even if they’re not a writer. \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jacqui Pretty\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Morgan James Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0